export default {
  basics: {
    Cancel: 'Hủy bỏ',
    Confirm: 'Xác nhận',
    en: 'EN',
    zh: 'ZH',
    PleaseSelect: 'Vui lòng chọn',
    PleaseInput: 'Please input',
  },
  schedule: {
    //节目编辑
    Screenshot: 'Ảnh chụp màn hình',
    ProgramName: 'Tên chương trình',
    Structure: 'Cấu trúc',
    Resolution: 'Độ phân giải',
    CreationTime: 'Thời gian sáng tạo',
    operate: 'Vận hành',
    AllLoaded: 'All loaded',
    materialsLoaded: 'Click to load material',
    NewProgram: 'New program',
    DelProgram: 'Xóa vĩnh viễn chương trình đã chọn?',
    DeleteMedia: 'Xóa phương tiện',
    DeleteProgram: '删除节目',
    //高级发布
  },
  review: {
    Screenshot: 'Ảnh chụp màn hình',
    ProgramName: 'Tên chương trình',
    Structure: 'Cấu trúc',
    Resolution: 'Độ phân giải',
    CreationTime: 'Thời gian sáng tạo',
    operate: 'Vận hành',
    Review: 'Đánh giá',
    Check: 'Kiểm tra',
    ProgramMaterial: 'Tài liệu chương trình',
    ProgramPreview: 'Đánh giá chương trình',
    ReviewContent: 'Vui lòng nhập nội dung đánh giá',
    Approved: 'Chấp thuận',
    RejectReview: 'Từ chối đánh giá',
    DeleteAll: 'Confirm delete all?',
    Name: 'Tên',
    Size: 'Size',
    Preview: 'Preview',
    ProgramReview: 'Đánh giá chương trình',
    ReasonRefusal: 'Please fill in the reason for refusal!',
    number: 'No release ticket number is selected',
  },
  system: {
    // 组织结构
    StructureName: 'Tên cấu trúc',
    Operate: 'Vận hành',
    NewStructure: 'Cấu trúc mới',
    DeleteStructure: 'Xóa cấu trúc',
    Structure: 'Cấu trúc',
    MsgDeleteStructure: 'Xóa vĩnh viễn hiện tại?',
    OnDevice: 'Turn on device',
    OffDevice: 'Turn off device',
    inquiry: 'IF',
    on: 'on',
    off: 'off',
    slaveDevice: 'the current or slave device',
    CloseCurrent: 'Close current',
    CloseSlave: 'Close slave',
    OpenCurrent: 'Open current',
    OpenSlave: 'Open slave',
    // 用户管理
    Account: 'Tài khoản',
    Name: 'Tên',
    Role: 'Vai Trò',
    Grade: 'Cấp',
    Remark: 'Nhận xét',
    RoleName: 'Tên vai trò',
    Password: 'Mật khẩu',
    ConfirmPass: 'Xác nhận mật khẩu',
    Mail: 'Địa chỉ email',
    DeleteUser: 'Xóa người dùng',
    DeleteRole: 'Permanently delete current role',
    UnblockDevice: 'Unblock device',
    banDevice: 'Ban device',
    Unblock: 'Unblock',
    ban: 'Forbidden',
    BanTheCurrent: 'Ban the current',
    BannedAffiliate: 'Banned affiliate',
    ReleaseTheCurrent: 'Release the current',
    ReleaseTheSubordinate: 'Release the subordinate',
    AddUser: 'Thêm người dùng',
    ModifyUser: 'Sửa đổi người dùng',
    inputPassword: 'Vui lòng nhập mật khẩu xác nhận',
    noPassword: 'Passwords entered twice do not match!',
    inputName: 'Vui lòng nhập tên',
    RoleEmpty: 'Tên vai trò không được để trống',
    StructureEmpty: 'Structure name cannot empty',
    AccountEmpty: 'Tài khoản không được để trống',
    AccountAstrict: 'Account only contain numbers, letters, and underscores!',
    AccountLength: 'Please set account length 3~20 characters!!',
    AccountRegistered: 'Current account has been registered, please re-enter!',
    // 角色管理
    AddRole: 'Thêm vai trò',
    RoleRemark: 'Nhận xét vai trò',
    RightConfig: 'Right config',
    DelRole: 'Xóa vai trò',
    // 系统设置
    imageSize1: 'Đề xuất 920x940 pixels ở định dạng PNG',
    ReplacePicture: 'Thay thế hình ảnh',
    LoginLogo: 'Logo trang đăng nhập',
    imageSize2: 'Đề xuất 360x80 pixels ở định dạng PNG',
    SystemLogo: 'Logo trang hệ thống',
    systemSettings: 'Các cài đặt hệ thống khác',
    configInformation: 'Thông tin cấu hình khác',
    DailyLimit: 'Giới hạn ứng dụng hàng ngày',
    UploadedType: 'Uploaded avatar image can only PNG format!',
    UploadedSize: 'Kích thước của ảnh đại diện tải lên không được vượt quá 2MB!',
    // 节点管理
    addNode: 'Add node',
    EnglishName: 'EnglishName',
    ChineseName: 'ChineseName',
    delNode: 'Permanently delete current role ?',
    // 软件授权
    AuthorizationType: 'Loại mã ủy quyền',
    Model: 'Model',
    Date: 'Ngày',
    AuthorizationCode: 'Mã ủy quyền',
    NewAccounts: '新建账号' // New accounts
  },
  // 节目编辑
  programEditing: {
    Setting: 'Setting',
    Save: 'Lưu',
    Release: 'Đăng bài',
    Quit: 'Thoát',
    ExitEditProgram: 'Thoát sẽ hủy chương trình chỉnh sửa hiện tại',
    DragMaterial: 'Drag the material file here',
    SaveWait: 'Screenshots and saving, please wait ...',
    ProgramList: 'Danh sách chương trình',
    multimedia: 'Multimedia',
    AddMultimedia: 'Add multimedia',
    Insert: 'Chèn vào vị trí hiện tại',
    properties: 'Đặc tính cửa sổ tài liệu',
    materialNull: 'Vui lòng thêm tài liệu vào cửa sổ',
    Uploaded: 'Uploaded',
    AllLoaded: 'All loaded',
    materialsLoaded: 'Click to load material',
    Text: 'Văn bản',
    Digital: 'Đồng hỗ kỹ thuật số',
    Analog: 'Đồng hồ kim',
    Weather: 'Thời tiết',
    Timing: 'Đếm thời gian',
    Countdown: 'Đếm ngược',
    StreamMedia: 'Phương tiện phát trực tiếp',
    RSS: 'RSS',
    Window: 'Cửa sổ',
    Picture: 'Hình ảnh',
    Video: 'Video',
    Delete: 'Xóa',
    Webpage: 'Webpage',
    OneLayerUp: 'Lên 1 lớp',
    OneLayerDown: 'Xuống 1 lớp',
    Top: 'Cạnh trên',
    Bottom: 'Cạnh dưới',
    Full: 'Toàn màn hình',
    HorizontalFull: 'Toàn màn hình ngang',
    VerticalFull: 'Toàn màn hình dọc',
    VerticalDown: 'Dọc xuống',
    VerticalMiddle: 'Dọc giữa',
    VerticalTop: 'Dọc trên',
    HorizontalLeft: 'Ngang trái',
    HorizontalCenter: 'Tâm ngang',
    HorizontalRight: 'Ngang phải',

    ProgramName: 'Tên chương trình',
    Structure: 'Cấu trúc',
    DeviceType: 'Loại thiết bị',
    Resolution: 'Độ phân giải',
    CustomResolution: 'Độ phân giải tùy chỉnh',
    Device: 'Device',
    SelectDevice: 'Vui lòng chọn thiết bị',
    SelectTerminal: 'Select publishing Terminal',
    TerminalName: 'Tên thiết bị',
    DeviceStatus: 'Trạng thái thiết bị',
    Offline: 'Ngoại tuyến',
    AdaptiveScreen: 'Kích thước màn hình tương thích',
    Tip: 'Gợi ý',
    Thumbnail: 'Thumbnail',
    Name: 'Tên',
    version: 'Version number',

    Title: 'Title',
    TimerMode: 'TimerMode',
    RelativeTime: 'RelativeTime',
    AbsoluteTime: 'AbsoluteTime',
    DisplayMode: 'DisplayMode',
    Day: 'Ngày',
    Hour: 'Giờ',
    Minutes: 'Phút',
    Second: 'Second',
    EditStyle: 'EditStyle',
    DisplayUsage: 'EditStyle',
    ARow: 'DT',
    MultiRow: 'MT',
    FontFamily: 'FontFamily',
    BackgroundColor: 'BackgroundColor',
    FontColor: 'FontColor',
    PlayTime: 'Thời gian chạy',
    Describe: 'Describe',
    HourMark: 'HourMark',
    HourHand: 'HourHand',
    MinutesMark: 'MinutesMark',
    MinutesHand: 'MinutesHand',
    background: 'background',
    secondHand: 'secondHand',
    DateAndDay: 'DateAndDay',
    Display: 'Display',
    SelectTimeZone: 'SelectTimeZone',
    Scale: 'Scale',
    ConstrainProportions: 'ConstrainProportions',
    EnterTheAnimation: 'EnterTheAnimation',
    TheEntryTime: 'TheEntryTime',
    Data: 'Ngày',
    Time: 'Time',
    ChineseCalendar: 'ChineseCalendar',
    Week: 'Week',
    DateFormat: 'DateFormat',
    Font: 'Font',
    Roll: 'Roll',
    FlipOver: 'FlipOver',
    Motionless: 'Motionless',
    RollingDirection: 'RollingDirection',
    RollingVelocity: 'RollingVelocity',
    FromLeftToRight: 'FromLeftToRight',
    FromRightToLeft: 'FromRightToLeft',
    FromTopToBottom: 'FromTopToBottom',
    FromTheBottomUp: 'FromTheBottomUp',
    Attribute: 'Attribute',
    AttendedMode: 'AttendedMode',
    EndToEnd: 'EndToEnd',
    VolumeAdjust: 'Điều chỉnh âm lượng',
    Duration: 'Duration',
    Address: 'Address',
    City: 'City',
    Temp: 'Nhiệt độ',
    WindPower: 'Sức gió',
    Humidity: 'Độ ẩm',
    DressingIndex: 'Trang phục khuyến cáo',
    PlayTheWay: 'PlayTheWay',
    TimeFormat1: '00:00:00:00',
    TimeFormat2: '00D00H00M00S',
  }
}